import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Modal, Table, Spinner, Alert, Row, Col, Form } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { toast } from 'react-toastify';
import ModalListPicker from '../../../components/Modals/ModalListPicker';
import { ApiManager } from '../../../core/api-manager';
import { CacheManager } from '../../../core/cache-manager';
import FormEntityInstanceCompiler from '../../../components/Entity/FormEntityInstanceCompiler';





export default function DGSH_pdc({ data, setData, selectedRows, setSelectedRows, refreshData, entity }) {

    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    /** shipping plan */
    const [showModalPicker, setShowModalPicker] = useState(false);
    const [showModalShippingPlan, setShowModalShippingPlan] = useState(false);
    const [shippingPlan, setShippingPlan] = useState(null);
    const [shippingPlanResponse, setShippingPlanResponse] = useState(null);
    const [shippingPlanLoading, setShippingPlanLoading] = useState(false);
    const [createShippingStatus, setCreateShippingStatus] = useState(null);

    const [forwarderList, setForwarderList] = useState(null)
    // Loading state for action buttons
    const [btnLoading, setBtnLoading] = useState(null);


    function openModalCreateShipping() {
        setCreateShippingStatus(true)
    }

    function closeModalCreateShipping() {
        setCreateShippingStatus(false)
    }

    async function getForwarder() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var res = await DataManager.getItemsSimple('forwarder', 1, 1000, sorting);
        if (res.success === 1) {
            setForwarderList(res.body)
        }
    }

    async function saveCreateShipping(el) {
        console.log(el)
        var res = await DataManager.insertItem('shipping_plan', el);
        console.log(res)
        if (res.success === 1) {
            var r = await DataManager.getItem('shipping_plan', parseInt(res.id))
            if (r.success === 1) {
                setShippingPlan(r.body[0])
                closeModalCreateShipping()
            }
        } else {
            toast.error('Errore nella creazione del piano.', { theme: 'colored' });
        }
    }


    function openModalShippingPlan() {
        setShowModalShippingPlan(true)
    }

    function closeModalShippingPlan() {
        setShowModalShippingPlan(false)
        setShippingPlan(null)
        setShippingPlanResponse([])
    }

    function selectRow(el) {
        setShippingPlan(el)
        closeModalPicker()
    }

    async function addRowsToShippingPlan() {
        if (shippingPlan) {
            setShippingPlanLoading(true)
            var success = 0
            var fail = 0
            var idPlan = shippingPlan.id
            for (var i = 0; i < selectedRows.length; i++) {
                var response = await DataManager.getItem('gyv_open_customer_rows', selectedRows[i]);
                console.log(response.body[0].idShippingPlan, parseInt(idPlan))
                if (response.body[0].idShippingPlan === parseInt(idPlan)) {
                    toast.error("Impossibile aggiungere la riga al piano di carico in quanto è già presente. Articolo: " + response.body[0].item_name, { theme: 'colored' })
                    continue;
                } else {
                    var idRow = response.body[0].id
                    var data = {
                        idCustomerOrderRow: { id: idRow },
                        idShippingPlan: { id: parseInt(idPlan) }
                    }

                    var responseInsert = await DataManager.insertItem('shipping_plan_rows', data);
                    console.log(responseInsert);
                    if (responseInsert.success === 1) {
                        var updateData = {
                            idShippingPlan: parseInt(idPlan)
                        }
                        var r = await DataManager.updateItem('customer_order_rows', updateData, selectedRows[i])
                        console.warn(r)
                        success = success + 1
                    } else {
                        fail = fail + 1
                        toast.error("Riga " + idRow + " non aggiunta.", { theme: 'colored' })
                    }
                }


            }
            setShippingPlanLoading(false)
            setShippingPlanResponse({ success: success, fail: fail })
            //closeModalShippingPlan();
        }
        else {
            toast.error("Seleziona un piano di consegna per proseguire.", { theme: 'colored' })
        }
    }

    function openModalPicker() {
        setShowModalPicker(true)
    }
    function closeModalPicker() {
        setShowModalPicker(false)
    }




    /** mrp */
    const [generateModal, setGenerateModal] = useState(false);
    const [generateStatus, setGenerateStatus] = useState(false);
    const [generateMsg, setGenerateMsg] = useState('');
    function closeModalGenerate() {
        setGenerateModal(false)
        setGenerateMsg('')
    }
    async function generate() {
        setGenerateModal(true)
        setGenerateStatus(false)

        const qParam = searchParams.get("q");
        let filtersSearch = null;

        if (qParam) {
            try {
                filtersSearch = atob(qParam);
            } catch (e) {
                console.error('Errore nel decode dei filtri MRP filtrato (PDC):', e);
                filtersSearch = null;
            }
        }

        var body = {
            rows: selectedRows,
            filtersSearch: filtersSearch
        }

        var response = await ApiManager.sendAuthenticatedRequest('/custom/mrp_generate_orders_filtered', body)
        //var response = await ApiManager.sendAuthenticatedRequest('/custom/mrp_generate_orders_filtered_v2', body)
        console.warn('GENERATE', response)
        if (response.success === 1) {
            setGenerateStatus(true)
        }
        else {
            setGenerateMsg(response.message)
        }
    }

    function pickingList() {
        const s = selectedRows.toString();
        //navigate('/page/PickingList?id=' + s)
        window.open('/page/PickingList?id=' + s)
    }


    function bindellaPreview() {
        const s = selectedRows.toString();
        //navigate('/page/BindellaOpenRow?id=' + s)
        window.open('/page/BindellaOpenRow?id=' + s)
    }



    const [documentStatus, setDocumentStatus] = useState(false);
    function closeModalDocument() {
        setDocumentStatus(false)
        setDocumentLoading(false);
    }
    async function openModalDocument() {
        try {
            setBtnLoading('doc');
            await getForwarder();
            setDocumentStatus(true)
        } finally {
            setBtnLoading(null);
        }
    }
    const [forwarder, setForwarder] = useState(null);
    const [aspectItem, setAspectItem] = useState(null);
    const [transportBy, setTransportBy] = useState(null);
    const [documentLoading, setDocumentLoading] = useState(false);


    async function generateDocument() {
        if (documentLoading) {
            return;
        }

        setDocumentLoading(true);

        try {
            if (!Array.isArray(selectedRows) || selectedRows.length === 0) {
                toast.error('Seleziona almeno una riga prima di generare i documenti.', { theme: 'colored' });
                return;
            }

            console.log(selectedRows)

            var constraints = [
                { fieldName: "id", type: "in", value: selectedRows.toString() },
            ]
            var sorting = {
                'field': 'id',
                'order': 'desc'
            }
            var resRows = await DataManager.searchItems('customer_order_rows', 1, 100, sorting, '', [], constraints);
            console.log(resRows)
            if (resRows.success !== 1 || !Array.isArray(resRows.body) || resRows.body.length === 0) {
                toast.error('Errore nel recupero delle righe ordine cliente.', { theme: 'colored' });
                return;
            }
            var arrayOrder = [];
            for (let i = 0; i < resRows.body.length; i++) {
                var resOrder = await DataManager.getItem('customer_order', resRows.body[i].idCustomerOrder)
                if (resOrder.success === 1 && Array.isArray(resOrder.body) && resOrder.body.length > 0) {
                    arrayOrder.push(resOrder.body[0]);
                }

            }
            console.log(arrayOrder)
            if (arrayOrder.length === 0) {
                toast.error('Impossibile generare i documenti: ordini cliente non trovati.', { theme: 'colored' });
                return;
            }
            const referenceOrder = arrayOrder[0];
            const checkCustomer = arrayOrder.every(item => item.idCustomer && item.idCustomer.id === referenceOrder.idCustomer.id);
            const checkAgent = arrayOrder.every(item => item.idSalesAgent && item.idSalesAgent.id === referenceOrder.idSalesAgent.id);
            const checkPayment = arrayOrder.every(item => item.idPaymentCondition && item.idPaymentCondition.id === referenceOrder.idPaymentCondition.id);
            const checkDelivery = arrayOrder.every(item => item.address && referenceOrder.address && item.address.id === referenceOrder.address.id);

            console.log(checkCustomer, checkAgent, checkDelivery, checkPayment);
            if (checkCustomer === false) {
                toast.error('Impossibile generare i documenti perché le righe selezionate non hanno lo stesso CLIENTE.', { theme: 'colored' })
            }
            if (checkAgent === false) {
                toast.error('Impossibile generare i documenti perché le righe selezionate non hanno lo stesso AGENTE.', { theme: 'colored' })
            }
            if (checkPayment === false) {
                toast.error('Impossibile generare i documenti perché le righe selezionate non hanno la stessa CONDIZIONE DI PAGAMENTO.', { theme: 'colored' })
            }
            if (checkDelivery === false) {
                toast.error('Impossibile generare i documenti perché le righe selezionate non hanno lo stesso INDIRIZZO DI CONSEGNA.', { theme: 'colored' })
            }
            if (checkCustomer === true && checkAgent === true && checkPayment === true && checkDelivery === true) {
                var rows = []
                for (let a = 0; a < resRows.body.length; a++) {
                    var row = {
                        idCustomerOrderRow: { id: resRows.body[a].id },
                        code: resRows.body[a].idItemModel.code,
                        description: resRows.body[a].idItemModel.name,
                        quantity: resRows.body[a].quantity,
                        price: resRows.body[a].total,
                        code: resRows.body[a].idItemModel.code,
                        notes: resRows.body[a].notes || null,
                        fulfilledQuantity: resRows.body[a].fulfilledQuantity
                    }
                    rows.push(row);
                }
                const total = resRows.body.reduce((acc, cur) =>
                    acc + parseFloat(cur.total)
                    , 0)
                const weight = resRows.body.reduce((acc, cur) =>
                    acc + parseFloat(cur.netWeight)
                    , 0)

                const packages = resRows.body.reduce((acc, cur) =>
                    acc + parseFloat(cur.packages)
                    , 0)
                const volume = resRows.body.reduce((acc, cur) =>
                    acc + parseFloat(cur.volume)
                    , 0)


                var data = {
                    idCustomerOrder: resRows.body[0].idCustomerOrder,
                    idShippingPlan: null,
                    packagesQuantity: packages,
                    weight: weight,
                    volume: volume,
                    forwarder: forwarder || null,
                    itemsAspect: {value: aspectItem || null},
                    transportBy: { value: transportBy || null },
                    status: { value: '0_PENDING' },
                    total: parseFloat(total).toFixed(2),
                    rows: rows
                }
                console.log(data);

                var res = await DataManager.insertItem('customer_transport_document', data);
                console.log(res)
                if (res.success === 1) {
                    // Imposta pdc a 0 per tutte le righe ordine cliente
                    for (let i = 0; i < selectedRows.length; i++) {
                        var updateBody = {
                            pdc: 0
                        }
                        await DataManager.updateItemNoCache('customer_order_rows', updateBody, selectedRows[i]);
                    }

                    toast.success('Documenti generati con successo', { theme: 'colored' })
                    closeModalDocument()
                    if (refreshData) {
                        refreshData();
                    }
                } else {
                    toast.error('Errore nella generazione dei documenti.', { theme: 'colored' });
                }
            }
        } catch (error) {
            console.error(error);
            toast.error('Errore nella generazione dei documenti.', { theme: 'colored' });
        } finally {
            setDocumentLoading(false);
        }
    }



    async function removePDC() {
        setBtnLoading('removePdc');
        console.log(selectedRows);
        const total = selectedRows.length;
        const loadingId = toast.loading(`Rimozione da PdC in corso... 0/${total}`, { theme: 'colored' });
        var count = 0;
        try {
            for (let i = 0; i < selectedRows.length; i++) {
                var body = {
                    pdc: 0
                }
                var res = await DataManager.updateItemNoCache('customer_order_rows', body, selectedRows[i]);
                if (res.success === 1) {
                    count++;
                    toast.update(loadingId, { render: `Rimozione da PdC in corso... ${count}/${total}`, isLoading: true });
                } else {
                    toast.error('Errore.', { theme: 'colored' })
                }
            }
            toast.update(loadingId, { render: count + ' righe rimosse da PdC con successo!', type: 'success', isLoading: false, autoClose: 500, theme: 'colored' });
            refreshData()
            await CacheManager.invalidateEntity(entity);
        } finally {
            setBtnLoading(null);
        }


    }



    return (
        <>
            <Row className='my-2'>
                <Col md={12} xs={6} className='pe-0 mb-2'>
                    <Button size='sm' variant='info' onClick={() => pickingList()} className='w-100' disabled={btnLoading === 'picking'}>
                        {btnLoading === 'picking' ? (<><Spinner animation="border" size="sm" className='me-2' />Generazione...</>) : 'Genera lista di carico'}
                    </Button>
                </Col>
                <Col md={12} xs={6} className='pe-0 mb-2'>
                    <Button size='sm' variant='secondary' onClick={() => bindellaPreview()} className='w-100' disabled={btnLoading === 'bindella'}>
                        {btnLoading === 'bindella' ? (<><Spinner animation="border" size="sm" className='me-2' />Stampa bindella...</>) : 'Stampa bindella'}
                    </Button>
                </Col>
                <Col md={12} xs={6} className='pe-0 mb-2'>
                    <Button variant='primary' size='sm' className='w-100' onClick={() => openModalShippingPlan()}>Aggiungi a piano di carico</Button>
                </Col>
                <Col md={12} xs={6} className='pe-0 mb-2'>
                    <Button size='sm' variant='success' onClick={() => openModalDocument()} className='w-100' disabled={btnLoading === 'doc'}>
                        {btnLoading === 'doc' ? (<><Spinner animation="border" size="sm" className='me-2' />Generazione...</>) : 'Genera documenti di spedizione'}
                    </Button>
                </Col>
                <Col md={12} xs={6} className='pe-0 mb-2'>
                    <Button size='sm' variant='outline-danger' onClick={() => removePDC()} className='w-100' disabled={btnLoading === 'removePdc'}>
                        {btnLoading === 'removePdc' ? (<><Spinner animation="border" size="sm" className='me-2' />Rimozione...</>) : 'Rimuovi da area preparazione PDC'}
                    </Button>
                </Col>
            </Row>


            {showModalShippingPlan ? (
                <>
                    <Modal show={showModalShippingPlan} onHide={closeModalShippingPlan} scrollable size={'md'}>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                Aggiungi al piano di consegna
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {shippingPlan ? (
                                <>
                                    <p className='small text-muted mb-0'>Hai selezionato il piano:</p>
                                    <p className='lead mt-0'>{shippingPlan.name} - id: {shippingPlan.id} - Data consegna: {shippingPlan.shippingDate}</p>
                                    {shippingPlanLoading ? (
                                        <Button>Aggiunta in corso <Spinner /></Button>
                                    ) : (
                                        <Button onClick={() => addRowsToShippingPlan()}>Aggiungi le righe selezionate</Button>
                                    )}

                                    {shippingPlanResponse && (
                                        <div className='mt-4'>
                                            <p className='text-success'>Righe inserite con successo: {shippingPlanResponse.success}</p>
                                            <p className='text-danger'>Righe non inserite: {shippingPlanResponse.fail}</p>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                    <Button onClick={() => openModalPicker()}>Seleziona piano</Button>
                                    <Button onClick={() => openModalCreateShipping()} variant='secondary' className='me-1'>Crea piano</Button>
                                </>

                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={closeModalShippingPlan}>
                                Chiudi
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <ModalListPicker modalStatus={showModalPicker} entity='shipping_plan_draft' closeModal={closeModalPicker} selectRow={selectRow} />
                </>
            ) : null}



            <Modal show={generateModal} onHide={closeModalGenerate} scrollable size={'md'}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Generazione articoli da ordinare in corso
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {generateMsg && generateMsg.length > 0 ? (
                        <Alert variant='danger'>{generateMsg}</Alert>
                    ) : (
                        <>
                            {generateStatus === false ? (
                                <>
                                    <Spinner />
                                    <br /><br />
                                    Riceverai una notifica quando l'operazione sarà completata.
                                </>
                            ) : (
                                <>
                                    <p className='text-success'>Elaborazione completata.</p>
                                </>
                            )}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeModalGenerate}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal show={documentStatus} onHide={closeModalDocument} scrollable size={'md'}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Generazione documenti
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {documentLoading && (
                        <div className='d-flex align-items-center mb-3'>
                            <Spinner animation="border" size="sm" className='me-2' />
                            <span>Generazione documenti in corso...</span>
                        </div>
                    )}
                    <Row style={{ pointerEvents: documentLoading ? 'none' : 'auto', opacity: documentLoading ? 0.6 : 1 }}>
                        <Col>
                            <Form.Label>Spedizioniere</Form.Label>
                            <Form.Select aria-label="Default select example" onChange={(e) => setForwarder(e.target.value)} disabled={documentLoading}>
                                <option>Seleziona</option>
                                {forwarderList && forwarderList.map((item, i) => {
                                    return (<><option value={item.name}>{item.name}</option></>)
                                })}
                            </Form.Select>
                        </Col>
                        <Col>
                            <Form.Label>Aspetto beni</Form.Label>
                            <Form.Select aria-label="Default select example" onChange={(e) => setAspectItem(e.target.value)} disabled={documentLoading}>
                                <option>Seleziona</option>
                                <option value="0_SCATOLE">Scatole</option>
                                <option value="5_VISTA">A vista</option>
                                <option value="10_PLURIBOL">Pluribol</option>
                                <option value="15_CARTONI">Cartoni</option>
                            </Form.Select>
                        </Col>
                        <Col>
                            <Form.Label>Trasporto a cura</Form.Label>
                            <Form.Select aria-label="Default select example" onChange={(e) => setTransportBy(e.target.value)} disabled={documentLoading}>
                                <option>Seleziona</option>
                                <option value="0_SENDER">Mittente</option>
                                <option value="1_RECIPIENT">Destinatario</option>
                                <option value="2_CARRIER">Vettore</option>
                            </Form.Select>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeModalDocument}>
                        Chiudi
                    </Button>
                    <Button variant="primary" onClick={generateDocument} disabled={documentLoading}>
                        {documentLoading ? (
                            <>
                                Generazione...
                                <Spinner animation="border" size="sm" className='ms-2' />
                            </>
                        ) : (
                            'Genera'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>





            <Modal show={createShippingStatus} onHide={closeModalCreateShipping} size={'xl'}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Crea piano di carico
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormEntityInstanceCompiler entity={'shipping_plan'} confirmCallback={saveCreateShipping} initData={{}} />
                </Modal.Body>
            </Modal>


        </>
    )
};
